module.exports = __webpack_public_path__ + "static/img/icon9.03e4a3b6.png";